import {React} from "react";
import './handwave-animation.css'
const Home = () => {
   
    return (
        <div className="bg-[#add3f7] w-screen h-screen md:pb-0 flex md:flex-row flex-col-reverse justify-center items-center gap-8">
            
            <video autoPlay muted playsInline loop>
                <source src="/assests/c9c680fa5df54165bdb45f17fdf7556e.webm"  type="video/webm"></source>
            </video>
                
           
            <div className=" flex flex-col gap-3 text-start px-2">
                <h3 class="text-4xl font-thin font-[Pacifico] text-[#ff0000]">Hi,<div className="wave-animation">👋</div>   I'm</h3>
                <h1 class="md:text-9xl  ms-[-2%] text-[17vw] font-[acme] text-black">Suraj Savji</h1>
                <h2 class="md:text-4xl text-[5vw] mt-[-3%] md:mt-0 font-semibold font-[Bree Serif] text-black" >Android developer</h2>
                <h2 class="md:text-2xl text-[4vw] font-[Bree Serif] text-black" >Backend developer</h2>
                <h2 class="md:text-4xl mt-5 text-[6vw] font-[Sevillana,cursive] md:mt-6 font-semibold text-gray-800">Software development is my passion !!</h2>

                <a className="mt-5 hover:bg-white font-[Noto Sans JP]  hover:text-[#003a76] hover:border-blue-950 hover:border bg-[#003a76] text-white md:w-52 w-44 self-end md:self-start font-medium text-lg text-center py-3 rounded-3xl" target="_blank" rel="noreferrer" href="assests\Suraj_Savji_Resume.pdf" ><button>Download CV</button></a>
                
            </div>
        </div>
    )
}

export default Home;